import isFavorite from "@/assets/is-favorite.svg";
import isFavoriteNeutral from "@/assets/is-favorite-neutral.svg";
import isFavoriteNot from "@/assets/is-favorite-not.svg";
import isTop from "@/assets/is-top.svg";
import isTopNeutral from "@/assets/is-top-neutral.svg";
import isTopNot from "@/assets/is-top-not.svg";
import isUrgent from "@/assets/is-urgent.svg";

export default {
  isFavorite,
  isFavoriteNeutral,
  isFavoriteNot,
  isTop,
  isTopNeutral,
  isTopNot,
  isUrgent
};
